import { CONFIG_SEO } from '~/constants'
import { TUserInfoResponse } from '~/features/user'

export const useUserSeo = function (user: TUserInfoResponse) {
  const title = computed(() => {
    const fullName = getFullname(user)
    const username =
      user.username && !/^\d+$/.test(user.username) ? `(${user.username})` : ''
    return `${fullName} ${username} | KungFuTech`.trim()
  })
  const description = computed(() => {
    const fullName = `${user.firstName} ${user.lastName}`.trim()
    const username = user.username || ''
    const followers = user.follows || 0
    return `Khám phá hồ sơ của ${fullName} trên KungFuTech. ${username ? `@${username} ` : ''}có ${followers} người theo dõi. Khám phá các bài viết, dự án và đóng góp của họ cho cộng đồng công nghệ. Tham gia KungFuTech để kết nối với ${fullName} và những người đam mê công nghệ khác.`
  })
  const thumbnail = computed(() => getThumbnail(user))
  const altThumb = computed(() => getAltThumbnail(user))
  const author = computed(() => getAuthor(user))

  return {
    title,
    description,
    thumbnail,
    altThumb,
    author,
  }
}

const getFullname = function (user: TUserInfoResponse): string {
  return `${user.firstName} ${user.lastName}`
}

const getThumbnail = function (user: TUserInfoResponse): string {
  return user?.imageUrl ? user?.imageUrl : CONFIG_SEO.IMAGE_THUMBNAIL
}
const getAltThumbnail = function (user: TUserInfoResponse): string {
  return `${user.firstName} ${user.lastName}`
}
const getAuthor = function (user: TUserInfoResponse): string {
  return user.username
}
